module.exports = __webpack_public_path__ + "media/images/card-3d830e59a09e7e5e66f463bc5276e882.png";